module.exports = __webpack_public_path__ + "static/track-focus-c02d6bc64e898bb181ef3352a82b6799.mp4";